import React, { Component } from "react";

class HomePage extends Component {
  componentDidMount() {
    // Update document title and meta tags
    document.title = "WatchCast";
    this.updateMetaTag("og:title", "WatchCast");
    this.updateMetaTag("og:description", "This site is meant to serve discussions...");
    this.updateMetaTag("og:image", "/images/WC_Logo.png");
  }

  updateMetaTag(property, content) {
    let meta = document.querySelector(`meta[property="${property}"]`);
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("property", property);
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", content);
  }

  getCurrentDate() {
    const date = new Date();
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = String(date.getDate()).padStart(2, "0");
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  render() {
    const styles = {
      container: {
        paddingBottom: "6px",
      },
      body: {
        background: "aliceblue",
      },
      largeText: {
        fontSize: "larger",
      },
      xLargeText: {
        fontSize: "x-large",
      },
      paddingTop: {
        paddingTop: "4px",
      },
      copyright: {
        paddingTop: "4px",
      },
    };

    return (
      <div style={styles.body}>
        <div style={styles.container}>
          <span style={styles.xLargeText}>
            Welcome to <b>WatchCast</b>
          </span>{" "}
          by{" "}
          <a href="mailto:aryeh.tuchfeld@gmail.com" rel="author">
            Aryeh Tuchfeld
          </a>.
        </div>
        <div style={styles.container}>This site is meant to serve discussions...</div>
        <div style={styles.container}>
          You can visit:{" "}
          <a href="/comments?title=public_room&from=homepage" target="_blank" rel="noopener noreferrer">
            <b>Public Chat Room</b>
          </a>{" "}
          (see description at{" "}
          <a href="https://github.com/relion/react-comments-chat" target="_blank" rel="noopener noreferrer">
            <b>github</b>
          </a>
          ) and my{" "}
          <a href="/comments?title=todo_list&from=homepage" target="_blank" rel="noopener noreferrer">
            <b>Todo List Room</b>
          </a>.
        </div>
        <div style={styles.container}>
          and{" "}
          <a href="/tnc" target="_blank" rel="noopener noreferrer">
            English <b>Bible Search</b>
          </a>.
        </div>
        <div style={styles.container}>
          <div style={styles.paddingTop}>
            <img src="/images/WC_Logo.png" alt="WatchCast Logo" />
          </div>
          <div>See also:</div>
          <div>
            my Starter Project -{" "}
            <a href="http://watchcast.live:5000/" target="_blank" rel="noopener noreferrer">
              <b>New FaithBit Site</b>
            </a>.
          </div>
          <div>
            some of{" "}
            <a href="/csm/Aryeh_FL_Songs.htm" target="_blank" rel="noopener noreferrer">
              my <b>Songs productions</b>
            </a>{" "}
            - using{" "}
            <a href="https://www.image-line.com/" target="_blank" rel="noopener noreferrer">
              FL Studio
            </a>{" "}
            and Karaokes, with presentation clips. also, some of{" "}
            <a href="https://soundcloud.com/aryeh-tuchfeld" target="_blank" rel="noopener noreferrer">
              my <b>Music Productions</b>
            </a>{" "}
            on SoundCloud.
          </div>
          <div>
            <a href="http://www.faithbit.org.il/SolDJ/" target="_blank" rel="noopener noreferrer">
              my <b>favorite Music</b>
            </a>{" "}
            with lyrics.
          </div>
          <div>
            <a href="https://www.facebook.com/aryeh.tuchfeld" target="_blank" rel="noopener noreferrer">
              me on <b>Facebook</b>
            </a>{" "}
            and some of{" "}
            <a href="https://www.facebook.com/TorahTalks" target="_blank" rel="noopener noreferrer">
              my <b>Bible Talks</b>
            </a>{" "}
            Page (in Hebrew). and{" "}
            <a href="https://www.facebook.com/relion.man" target="_blank" rel="noopener noreferrer">
              another account of mine on <b>Facebook</b>
            </a>.
          </div>
          <div>
            <a href="http://www.faithbit.org.il/" target="_blank" rel="noopener noreferrer">
              my Main <b>Bible Project</b>
            </a>{" "}
            &nbsp;(in Hebrew).
          </div>
          <div>
            some of{" "}
            <a href="https://photos.app.goo.gl/GL9TDRniE151ri5C9" target="_blank" rel="noopener noreferrer">
              my favorite <b>Programmers Jokes</b>
            </a>.
          </div>
          <div>
            some of{" "}
            <a href="https://photos.app.goo.gl/Q7V12EDjqDmrAAju9" target="_blank" rel="noopener noreferrer">
              my favorite <b>"Life Attitude"</b> movie clips
            </a>.
          </div>
          <div>
            some of{" "}
            <a href="https://github.com/relion" target="_blank" rel="noopener noreferrer">
              <b>my Programming Projects on github</b>
            </a>.
          </div>
          <div>
            some of{" "}
            <a href="https://photos.app.goo.gl/pAgUdewrmyoUYJpY7" target="_blank" rel="noopener noreferrer">
              <b>my favorite pics</b>
            </a>.
          </div>
          <div style={styles.copyright}>
            <i>© {this.getCurrentDate()} Aryeh@FaithBit Aryeh@FaithBit</i>
          </div>
        </div>
      </div>
    );
  }
}

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/HomePage.js